var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterestIcon(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 34,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M11.188 21.338c-.55 2.412-1.092 4.74-2.27 6.576-.36.562-.72 1.27-1.338 1.572-.912-4.687.993-8.63 1.745-12.57-.96-1.957-.364-5.27 1.692-5.647 2.972-.55 2.19 3.04 1.685 4.71-.278.91-.777 1.79-.7 2.79.164 2.11 2.826 2.25 4.19 1.16 1.956-1.56 2.52-4.57 2.33-7.04-.29-3.77-4.555-5.64-8.322-4.14-1.94.78-3.702 2.56-3.96 5.18-.132 1.38.157 2.48.702 3.26.08.12.364.33.405.64.085.63-.293 1.32-.64 1.8-1.93-.56-2.925-2.29-3.085-4.48-.362-4.99 3.732-8.79 8.554-9.14 5.147-.38 9.225 2.59 9.605 6.93.29 3.21-.86 6.46-2.67 8.2-1.36 1.31-4.26 2.59-6.63 1.34-.52-.28-.75-.62-1.28-1.17"
  })));
}
export default SvgPinterestIcon;